import React from "react";
import { Popper } from "@material-ui/core";

const AutoCompletePopper = ({ minWidth = 250, maxWidth = 400, ...props }) => {
  return (
    <Popper
      {...props}
      style={{ minWidth, maxWidth }}
      placement="bottom-start"
    />
  );
};

export default AutoCompletePopper;
